import styled from "styled-components";
import * as global from './../../components/helpers/Helper'

export const FooterContainer = styled.footer`
  background-color: ${global.ColorFooter};
  width: 100%;
`
export const FooterMax = styled.div`
  max-width: 1400px;
  width: 95%;
  margin: 0px auto;
  padding: 12px 0px;
  display: grid;
  gap: 6px;
  @media (min-width: 768px) {
    grid-template-areas: 
    "logo social";
  }
`
export const FooterSocial = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  & svg {
    cursor: pointer;
    font-size: 40px;
    color: ${global.ColorMain};
    @media (min-width: 992px) {
      transition: .5s all;
      &:hover {
        color: ${global.ColorRed};
        transition: .5s all;
      }
    }
  }
  @media (min-width: 768px) {
    grid-area: social;
    justify-content: flex-end;
  }
`
export const FooterLogo = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;
  & img {
    height: 50px;
  }
  & p {
    color: ${global.ColorMain};
    font-size: 18px;
    @media (min-width: 992px) {
      font-size: 22px;
    }
  }
  @media (min-width: 769px) {
    grid-area: logo;
    justify-content: flex-start;
  }
`
export const Dyaded = styled.a`
  color: ${global.ColorRed};
  font-weight: bold;
`